<template>
  <div>
    <vue-snotify></vue-snotify>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      :loader="$store.state.spinerLoader"
      :color="$store.state.spinerColor"
    ></loading>
    <b-row>
      <b-col lg="2">
        <div>
          <b-button
            block
            variant="outline-primary"
            @click="setActiveTab(1)"
            :class="active_tab == 1 ? 'active' : ''"
          >
            <i class="fa-solid fa-users"></i>
            User
            <i class="fa-solid fa-upload"></i>
          </b-button>
          <label class="label label-size text-muted">{{
            userLastModified
          }}</label>
          <b-button
            block
            variant="outline-primary"
            @click="setActiveTab(2)"
            :class="active_tab == 2 ? 'active' : ''"
          >
            <i class="fa-solid fa-users"></i>
            Client
            <i class="fa-solid fa-upload"></i>
          </b-button>
          <label class="label label-size text-muted">{{
            clientLastModified
          }}</label>
          <b-button
            block
            variant="outline-primary"
            @click="setActiveTab(3)"
            :class="active_tab == 3 ? 'active' : ''"
          >
            <i class="fa-solid fa-list"></i>
            Tax Centers
            <i class="fa-solid fa-upload"></i>
          </b-button>
          <label class="label label-size text-muted">{{
            taxCenterLastModified
          }}</label>
        </div>
      </b-col>
      <b-col lg="10">
        <div v-if="active_tab == 1">
          <UsersUpload />
        </div>
        <div v-if="active_tab == 2">
          <ClientUpload />
        </div>
        <div v-if="active_tab == 3">
          <ClientTaxUpload />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "./../Vuetable/VuetablePaginationBootstrap4.vue";
import ClientUpload from "./Uploads/Clients/ClientUpload.vue";
import UsersUpload from "./Uploads/Users/UsersUpload.vue";
import ClientTaxUpload from "./Uploads/ClientsTax/ClientTaxUpload.vue";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import mixins from "./../../mixins/common.js";

export default {
  components: {
    Vuetable,
    VuetablePagination,
    ClientUpload,
    UsersUpload,
    ClientTaxUpload,
  },
  mixins: [mixins],
  data() {
    return {
      excel_file: null,
      perPage: 10,
      allClients: [],
      excelData: [],
      fullPage: true,
      isLoading: false,
      excelError: null,
      active_tab: 1,
      userLastModified: "",
      clientLastModified: "",
      taxCenterLastModified: "",
    };
  },
  watch: {
    excelData(newVal, oldVal) {
      this.$refs.vuetableExcel.refresh();
    },
  },
  methods: {
    ...mapActions("admin", [
      "excelFileRead",
      "confirmFileUpload",
      "userUploadLastModified",
      "claimUploadLastModified",
      "taxCenterUploadLastModified",
    ]),
    refreshLastModified() {
      this.userUploadLastModified().then((data) => {
        if (data.data && data.data.data) {
          this.clientLastModified = data.data.data.clientCreatedString;
          this.userLastModified = data.data.data.userCreatedString;
        }
      });
      this.taxCenterUploadLastModified().then((data) => {
        if (data.data && data.data.data) {
          this.taxCenterLastModified = data.data.data.taxCenterCreatedString;
        }
      });
    },
    setActiveTab(tab) {
      this.active_tab = tab;
    },
    confirmAction() {
      this.isLoading = true;
      this.confirmFileUpload().then((data) => {
        if (data.data.success && data.data.success.status) {
          this.excelError = null;
          this.excelData = [];
        }
        this.isLoading = false;
      });
    },
    uploadExcelFile() {
      this.isLoading = true;
      let formData = new FormData();
      formData.append("file", this.excel_file);

      this.excelFileRead(formData).then((data) => {
        if (data.data.error.status == "false") {
          this.excelError = 0;
        } else {
          this.excelError = 1;
        }
        if (data.data.data) {
          this.excelData = _.values(data.data.data);
          this.$bvModal.hide("bv-modal-example-2");
        } else {
        }

        this.isLoading = false;
      });
    },
    onPaginationDataAllClients(paginationData) {
      this.$refs.pagination_allclients.setPaginationData(paginationData);
    },
    onChangePageAllClients(page) {
      this.$refs.vuetableAllClients.changePage(page);
    },
    dataManagerAllClients(sortOrder, pagination) {
      let local = [];

      local = this.allClients;

      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }

      pagination = this.$refs.vuetableAllClients.makePagination(
        local.length,
        this.perPage
      );
      let from = pagination.from - 1;
      let to = from + this.perPage;
      return {
        pagination: pagination,
        data: _.slice(local, from, to),
      };
    },

    onPaginationDataExcel(paginationData) {
      this.$refs.pagination_excel.setPaginationData(paginationData);
    },
    onChangePageExcel(page) {
      this.$refs.vuetableExcel.changePage(page);
    },
    dataManagerExcel(sortOrder, pagination) {
      let local = [];

      local = this.excelData;

      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }

      pagination = this.$refs.vuetableExcel.makePagination(
        local.length,
        this.perPage
      );
      let from = pagination.from - 1;
      let to = from + this.perPage;
      return {
        pagination: pagination,
        data: _.slice(local, from, to),
      };
    },
  },
  computed: {},
  mounted() {
    this.refreshLastModified();
    //clear snotofy 
    this.clearSnotifyMessages();
  },
};
</script>

<style scoped>
.label-size {
  font-size: 0.7rem;
  font-weight: 300;
  line-height: 1.7;
}

.color-block {
  margin-left: 2px;
  margin-right: 2px;
  margin-top: 5px;
  float: right;
  min-height: 12px;
  min-width: 12px;
  max-height: 12px;
  max-width: 12px;
}
</style>
